<template>
  <gl-layout header-title="华夏乐游账户中心" :user-name="userName"></gl-layout>
</template>

<script>
import GlLayout from 'components/layout/Index'

export default {
  computed: {
    userName() {
      return this.$store.getters.userInfo.nickname
    }
  },
  components: {
    GlLayout
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/user-basic/views/layout/Index.vue